
import { createApp } from 'vue'
import App from './App.vue'

// Vuetify
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css' // ✅ Import MDI icons
import vuetify from './plugins/vuetify' // ✅ Use Vuetify plugin

// Optional: Vue Router and Store
import router from './router'
import store from './store'

const app = createApp(App)

app.use(vuetify)
app.use(router)
app.use(store)

app.mount('#app')
